import React, { useState, useRef, useEffect } from 'react';
import '../../../styles/resume-editor.css';
import { CustomSectionEntry } from './CustomSectionExpanded';

interface CustomSectionEntryCardProps {
  entry: CustomSectionEntry & { id: string };
  layout: 'inline' | 'stacked';
  onEdit: (entry: CustomSectionEntry & { id: string }) => void;
  onDelete: (id: string) => void;
}

export const CustomSectionEntryCard: React.FC<CustomSectionEntryCardProps> = ({
  entry,
  layout,
  onEdit,
  onDelete,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  const formatDate = (date: Date | null | undefined): string => {
    if (!date) return '';
    if (entry.yearOnly) {
      return date.getFullYear().toString();
    }
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${month} ${year}`;
  };

  const formatDateRange = (): string => {
    if (entry.hideDate) return '';
    const startDate = formatDate(entry.date);
    const endDate = entry.hideEndDate ? '' : formatDate(entry.endDate);
    
    if (startDate && endDate) {
      return `${startDate} to ${endDate}`;
    } else if (startDate) {
      return startDate;
    }
    return '';
  };

  return (
    <div className="resume-editor__experience-card" style={{ marginBottom: layout === 'inline' ? '8px' : '12px', paddingTop: '8px', position: 'relative' }}>
      <div className="resume-editor__experience-card-menu-container" ref={menuRef} style={{ position: 'absolute', top: '8px', right: '10px' }}>
        <button 
          className="resume-editor__experience-card-menu" 
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ⋮
        </button>
        {menuOpen && (
          <div className="resume-editor__experience-card-dropdown">
            <button
              className="resume-editor__experience-card-dropdown-item"
              onClick={() => {
                onEdit(entry);
                setMenuOpen(false);
              }}
            >
              Edit entry
            </button>
            <button
              className="resume-editor__experience-card-dropdown-item resume-editor__experience-card-dropdown-item--delete"
              onClick={() => {
                onDelete(entry.id);
                setMenuOpen(false);
              }}
            >
              Delete entry
            </button>
          </div>
        )}
      </div>

      <div style={{ textAlign: 'left' }}>
        <h3 className="resume-editor__experience-card-title" style={{ textAlign: 'left', margin: '0', marginBottom: formatDateRange() ? '4px' : (entry.description ? '8px' : '0') }}>
          {entry.title}
        </h3>

        {formatDateRange() && (
          <p className="resume-editor__experience-card-date" style={{ textAlign: 'left', marginBottom: entry.description ? '8px' : '0', marginTop: '0' }}>
            {formatDateRange()}
          </p>
        )}

        {entry.description && (
          <p className="resume-editor__experience-card-description" style={{ textAlign: 'left', marginTop: formatDateRange() ? '0' : '8px', marginBottom: '0' }}>
            {entry.description}
          </p>
        )}
      </div>
    </div>
  );
};

